import {
    SET_PRICE_INFO,
} from "./PriceInfoType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_PRICE_INFO:
            return {
                ...state,
                priceInfo: action.priceInfo,
            };
        default:
            return state;
    }
};

export default reducer;
